import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
  onActionEditar: (
    Id: number | null,
    openState: boolean,
    openAnalise: boolean,
  ) => void;
  onActionDeletar: (Id: number | null, openState: boolean) => void;
  onActionModal: (
    IdDiarioObrasEfetivo: number | null,
    openState: boolean,
  ) => void;
  read: boolean;
};

export const GenerateEfetivoColumns = ({
  onActionEditar,
  onActionDeletar,
  onActionModal,
  read,
}: Props): GridColDef[] => {
  const StatusBadge = ({
    label,
    color,
  }: {
    label: string;
    color: "green" | "yellow" | "blue";
  }) => {
    const bgClass =
      color === "green"
        ? "bg-[#009688]"
        : color === "yellow"
          ? "bg-[#FFC107]"
          : "bg-[#00BCD4]";
    return (
      <div
        className={`${bgClass} text-white px-2 py-1 rounded text-xs font-bold uppercase w-full text-center`}
      >
        {label}
      </div>
    );
  };

  return [
    {
      field: "NomeCargo",
      filterable: false,
      headerName: "Cargo",
      minWidth: 250,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-all w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Descricao",
      filterable: false,
      headerName: "Descricao",
      minWidth: 200,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-all w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Tipo",
      filterable: false,
      headerName: "Mão de Obra",
      width: 140,
      sortable: false,
      renderCell: (params) => {
        const isPropria = params.value === 0;
        return (
          <div className="w-full h-full flex justify-center items-center">
            <StatusBadge
              label={isPropria ? "Própria" : "Terceirizada"}
              color={isPropria ? "green" : "yellow"}
            />
          </div>
        );
      },
    },
    {
      field: "Categoria",
      filterable: false,
      headerName: "Categoria Mão de Obra",
      width: 180,
      sortable: false,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) {
          return (
            <div className="w-full h-full flex justify-center items-center">
              <span className="text-gray-500 font-medium">N/A</span>
            </div>
          );
        }
        const isPropria = params.value === 0;
        return (
          <div className="w-full h-full flex justify-center items-center">
            <StatusBadge
              label={isPropria ? "Administrativa" : "Operacional"}
              color={isPropria ? "green" : "yellow"}
            />
          </div>
        );
      },
    },
    {
      field: "NomeFornecedor",
      filterable: false,
      headerName: "Fornecedor",
      flex: 1.5,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-all w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Quantidade",
      filterable: false,
      headerName: "Quantidade",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <span className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {params.value}
          </span>
        );
      },
    },
    {
      field: "Funcionarios",
      filterable: false,
      headerName: "Visualizar Funcionarios",
      width: 170,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <Button
              onMouseDown={(e) => {
                onActionModal(params.row.IdDiarioObrasEfetivo, true);
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: ".4rem",
                paddingY: 0,
                background: "#e6e6e6",
                borderLeft: ".2rem solid #45b6af",
                borderRadius: 0,
                color: "black",
                fontWeight: "normal",
              }}
            >
              Funcionarios
            </Button>
          </div>
        );
      },
    },
    {
      field: "IdDiarioObrasEfetivo",
      sortable: false,
      filterable: false,
      headerName: "Ações",
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        if (read !== false) return null;

        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onClick={() => onActionEditar(params.value, true, false)}
            >
              <DynamicIcon
                nameIcon="EditRounded"
                size={25}
                className="dark:text-white text-primary-green"
              />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={25}
                className="text-red-500"
              />
            </IconButton>
          </div>
        );
      },
    },
  ];
};
